const URL = window.location.protocol + "//" + window.location.hostname;

export const config = {
  BASE_URL: (process.env.NODE_ENV === 'development') ? 'https://localhost:44404' : URL,
  API_URL: (process.env.NODE_ENV === 'development') ? '/api' : URL + '/api',
  MAP_APi: process.env.REACT_APP_MAP_API,
  Upload_File_Extensions: [ 'pdf','xls','xlsx','bmp','jpg','jpeg','png','doc','docx','ppt','pptx','zip','rar','txt'],
  Max_File_Size: 10000000
};
